/**
 * Common configurations used across multiple pages.
 */

import { UI_ICONS, WALLET_FEATURE_ICONS } from './icons';
import { THEME_COLORS, SHADOWS } from './colors';

export { UI_ICONS } from './icons';

export interface PaymentMethod {
  value: string;
  labelKey: string;
  short: string;
  rateKey?: string;
}

/**
 * Payment methods used in trading and fuel purchase
 */
export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    value: 'usdt',
    labelKey: 'buyFuel.methods.usdt',
    short: 'USDT',
    rateKey: 'buyFuel.rates.usdt',
  },
  {
    value: 'bank',
    labelKey: 'buyFuel.methods.bank',
    short: 'BANK',
    rateKey: 'buyFuel.rates.cny',
  },
  {
    value: 'alipay',
    labelKey: 'buyFuel.methods.alipay',
    short: 'ALI',
    rateKey: 'buyFuel.rates.cny',
  },
  {
    value: 'wechat',
    labelKey: 'buyFuel.methods.wechat',
    short: 'WX',
    rateKey: 'buyFuel.rates.cny',
  },
] as const;

/**
 * Chinese payment methods
 */
export const EP_SELL_PAYMENT_METHODS = [
  { value: '銀行轉帳', labelKey: 'epSell.bankTransfer' },
  { value: '微信', labelKey: 'epSell.wechat' },
  { value: '支付寶', labelKey: 'epSell.alipay' },
  { value: 'USDT', labelKey: 'epSell.usdt' },
] as const;

/**
 * Trading payment options
 */
export const TRADING_PAYMENT_OPTIONS = ['bank', 'alipay', 'wechat', 'usdt'] as const;
export type TradingPaymentMethod = (typeof TRADING_PAYMENT_OPTIONS)[number];

/**
 * Drawer menu structure
 */
export interface DrawerItem {
  labelKey: string;
  to?: string;
  icon: string;
}

export const DRAWER_MENU_ITEMS: DrawerItem[] = [
  { labelKey: 'menu.home', to: '/wallet', icon: UI_ICONS.home },
  { labelKey: 'menu.uo_trading', to: '/trading', icon: UI_ICONS.wallet },
  { labelKey: 'menu.my_uo', to: '/me', icon: UI_ICONS.person },
  { labelKey: 'menu.ep_trading', to: '/ep-hub', icon: UI_ICONS.refresh },
  { labelKey: 'menu.exchange_calc', to: '/exchange-calc', icon: UI_ICONS.globe },
  { labelKey: 'menu.buy_fuel', to: '/buy-fuel', icon: UI_ICONS.fuel },
];

/**
 * Wallet features
 */
export const WALLET_FEATURES = [
  { labelKey: 'wallet.uo_trading', to: '/trading', icon: WALLET_FEATURE_ICONS.uoTrading },
  { labelKey: 'wallet.ep_trading', to: '/ep-hub', icon: WALLET_FEATURE_ICONS.epTrading },
  { labelKey: 'wallet.sell_uo', to: '/otc', icon: WALLET_FEATURE_ICONS.sellUo },
  { labelKey: 'wallet.fuel', to: '/buy-fuel', icon: WALLET_FEATURE_ICONS.fuel },
] as const;

/**
 * Drawer languages
 */
export const DRAWER_LANGUAGES = [
  { code: 'zh', label: '中文' },
  { code: 'en', label: 'ENG' },
] as const;

export type DrawerLanguageCode = (typeof DRAWER_LANGUAGES)[number]['code'];

export const DRAWER_COLORS = {
  borderDrawer: THEME_COLORS.borderDrawer,
  bgDrawer: THEME_COLORS.glassBg,
  shadowDrawer: SHADOWS.shadowDrawer,
  borderHeader: SHADOWS.otherShadow,
  headerText: THEME_COLORS.headerText,
  iconClose: THEME_COLORS.gold,
  divider: THEME_COLORS.softDivider,
  bgLanguage: THEME_COLORS.bgLanguage,
  languageText: '#9CA3AF',
} as const;
